import {Registers} from './Registers';
export default Registers;